import 'normalize.css';

import { App as AntdApp, ConfigProvider } from 'antd';
import type { ReactElement } from 'react';
import { useEffect, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import AuthContext, { type IAuthContext } from './context/AuthContext';
import useKeycloak from './hooks/keycloak';
import { useSurveyInboundHash } from './hooks/useSurveyInboundHash';
import { buildSurveyRouteObjects } from './routes/surveyRoutes.config';
import { rootStore } from './store';
import { FETCH_PROFILE_START } from './store/profile';
// import { SET_PROFILE_FULFILL } from './store/profile';
import { adaptDesignTokensToAntd } from './theme/adaptDesignTokensToAntd';

/**
 * Корневой компонент: Keycloak bootstrap, AuthContext, диспатч загрузок по токену и маршрутизация.
 * @returns {ReactElement}
 */
export function App(): ReactElement {
  const { kLogin, kLogout, kRefresh, kToken, initStatus, initError, kProfile } = useKeycloak({ mocked: false });
  useSurveyInboundHash();

  const authValue: IAuthContext = useMemo(
    () => ({
      login: kLogin,
      logout: kLogout,
      refresh: kRefresh,
      kToken,
      initStatus,
      initError,
      kProfile,
    }),
    [kLogin, kLogout, kRefresh, kToken, initStatus, initError, kProfile],
  );

  useEffect(() => {
    if (typeof kToken !== 'string') {
      return;
    }
    rootStore.dispatch({ type: FETCH_PROFILE_START, payload: { token: kToken } });
  }, [kToken]);

  const router = useMemo(
    () => createBrowserRouter(buildSurveyRouteObjects({ initStatus, initError, kToken })),
    [initStatus, initError, kToken],
  );

  const theme = adaptDesignTokensToAntd();

  return (
    <AuthContext.Provider value={authValue}>
      <ConfigProvider theme={theme}>
        <AntdApp>
          <RouterProvider router={router} />
        </AntdApp>
      </ConfigProvider>
    </AuthContext.Provider>
  );
}
